import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorToastContent(props) {
    const injectedProps = props; // ToastContentProps is injected by react-toastify
    return (_jsxs(_Fragment, { children: [_jsx("p", { children: injectedProps.message }), injectedProps.error && (_jsx("pre", Object.assign({ style: {
                    overflow: "scroll",
                    maxHeight: 300,
                } }, { children: _jsx("code", { children: injectedProps.error.message }) })))] }));
}
export default ErrorToastContent;
//# sourceMappingURL=ErrorToastContent.js.map